import { render, staticRenderFns } from "./CustomBottom.vue?vue&type=template&id=dd4c64b0&scoped=true"
import script from "./CustomBottom.vue?vue&type=script&lang=js"
export * from "./CustomBottom.vue?vue&type=script&lang=js"
import style0 from "./CustomBottom.vue?vue&type=style&index=0&id=dd4c64b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4c64b0",
  null
  
)

export default component.exports